import { useEffect, useState, useRef } from "react";

export default function Tabs({ selectedTab, tabs, onTabClick }) {
    const tabRef = useRef(null);
    const [indicatorStyle, setIndicatorStyle] = useState({});

    useEffect(() => {
        if (tabRef.current) {
            const activeTab = tabRef.current.querySelector(".tab-selected");
            if (activeTab) {
                setIndicatorStyle({
                    width: `${activeTab.offsetWidth}px`,
                    transform: `translateX(${activeTab.offsetLeft}px)`,
                });
            }
        }
    }, [selectedTab, tabs]);

    return (
        <>
            <div className="tab-list" ref={tabRef}>
                {tabs.map((i) => (
                    <div
                        key={i.id}
                        onClick={() => onTabClick(i.id)}
                        className={`tab-item ${selectedTab === i.id ? "tab-selected" : ""}`}
                    >
                        {i.title}
                    </div>
                ))}
                <div className="tab-indicator" style={indicatorStyle}></div>
            </div>
        </>
    );
}